<template>
  <div class="hundred-number-container">
    <div class="header">
      <div class="left">
        <h2 class="title">{{ hundredNum.title }}</h2>
        <span class="new">{{ hundredNum.new }}</span>
      </div>
      <div class="right">
        <a><span @click="handleClick(moreUrl)">更多</span>》</a>
      </div>
    </div>
    <div class="content" v-if="hundredNum.title === '百家号'">
      <div
        class="item"
        v-for="(item, index) in hundredNum.itemList"
        :key="index"
        @click="goBjDetails(item)"
      >
        <img v-lazy="$global.imgUrl + item.headPhoto" alt="" v-if="item.headPhoto" />
        <img :src="require('@/assets/img/login/4.png')" alt="" v-else />
        <h2 class="name">{{ item.name }}</h2>
        <!-- <p class="school" v-if="item.school">{{ item.school }}</p> -->
        <p class="doctor">
          <span v-for="v in item.title" :key="v.id">{{
            v.levelThreeName
          }}</span>
        </p>
        <p class="doctor">{{ item.unit }}</p>
      </div>
    </div>
    <div class="content" v-else>
      <div
        class="item"
        v-for="(item, index) in hundredNum.itemList"
        :key="index"
        @click="goBjDetails(item)"
      >
        <img v-lazy="$global.imgUrl + item.periodicalLogo" alt="" />
        <h2 class="name">{{ item.name }}</h2>
        <!-- <p class="school" v-if="item.school">{{ item.school }}</p> -->
        <p class="doctor">
          <span v-for="v in item.title" :key="v.id">{{
            v.levelThreeName
          }}</span>
        </p>
        <p class="createTime" v-if="item.foundedDate">
          创刊时间：{{ item.foundedDate }}年
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hundredNum: {
      type: Object,
      required: true,
    },
    moreUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    goBjDetails(item) {
      this.$emit("goBjDetails", item);
    },
    handleClick(moreUrl) {
      let routeUrl;
      if (moreUrl === "/bjzx") {
        routeUrl = this.$router.resolve({
          path: moreUrl,
          query: { title: "百家在线" },
        });
      } else {
        routeUrl = this.$router.resolve({
          path: moreUrl,
          query: { title: "百科在线" },
        });
      }
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.hundred-number-container {
  width: 100%;
  height: 338px;
  background-color: #ffffff;
  padding: 25px 46px 45px 20px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  margin-top: 6px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      .title {
        font-size: 22px;
        color: #1d52eb;
        font-weight: 400;
        margin-right: 11px;
      }
      .new {
        font-size: 12px;
        color: #9c9c9c;
        line-height: 3;
      }
    }
    .right {
      .more {
        font-size: 14px;
        color: #1d52eb;
        cursor: pointer;
        span {
          vertical-align: middle;
        }
      }
    }
  }
  .content {
    margin-top: 49px;
    display: flex;
    overflow: hidden;
    .createTime {
      white-space: nowrap;
    }
    .item {
      text-align: center;
      margin-left: 45px;
      cursor: pointer;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      .name {
        margin-bottom: 14px;
        font-size: 18px;
        font-weight: bold;
        color: #263d78;
        width: 110px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .school,
      .doctor {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        width: 112px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
